import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ArrowDownRight, ArrowRight, ArrowUpRight } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@shared/ui/card';
import { Badge } from '@shared/ui/badge';
import { cn } from '@shared/utils/cn';
import { useTranslation } from 'react-i18next';
const getVariationConfig = (variation, stableLabel) => {
    if (variation === undefined) {
        return {
            label: stableLabel,
            icon: ArrowRight,
            className: 'text-muted-foreground',
            badgeVariant: 'neutral',
        };
    }
    if (variation > 0) {
        return {
            label: `+${variation.toFixed(1)}%`,
            icon: ArrowUpRight,
            className: 'text-secondary',
            badgeVariant: 'success',
        };
    }
    if (variation < 0) {
        return {
            label: `${variation.toFixed(1)}%`,
            icon: ArrowDownRight,
            className: 'text-destructive',
            badgeVariant: 'danger',
        };
    }
    return {
        label: '0%',
        icon: ArrowRight,
        className: 'text-muted-foreground',
        badgeVariant: 'neutral',
    };
};
export const KpiCard = ({ title, value, variation, format, testId }) => {
    const { t } = useTranslation('dashboard');
    const { label, icon: Icon, badgeVariant } = getVariationConfig(variation, t('kpi.stable'));
    const displayValue = format ? format(value) : value.toLocaleString();
    return (_jsxs(Card, { className: "relative overflow-hidden p-0", "data-testid": testId, children: [_jsxs(CardHeader, { className: "mb-1 flex items-center justify-between gap-2 px-4 pt-4", children: [_jsxs("div", { children: [_jsx(CardDescription, { className: "text-[11px] uppercase tracking-[0.14em]", children: title }), _jsx(CardTitle, { className: cn('mt-1 text-2xl font-semibold leading-tight', 'bg-gradient-to-r from-sky-300 via-emerald-300 to-indigo-300 bg-clip-text text-transparent'), children: displayValue })] }), _jsx("div", { className: "flex flex-col items-end gap-1", children: _jsxs(Badge, { variant: badgeVariant, className: "flex items-center gap-1", children: [_jsx(Icon, { className: "h-3 w-3" }), _jsx("span", { children: label })] }) })] }), _jsx(CardContent, { className: "px-4 pb-4 pt-1", children: _jsx("div", { className: "h-1.5 w-full overflow-hidden rounded-full bg-slate-900/70", children: _jsx("div", { className: "h-full w-2/3 bg-gradient-to-r from-sky-500 via-emerald-400 to-rose-500" }) }) })] }));
};
